export const handleWithoutPropagation = (action = () => {}) => {
    return  (event) => {
        event.stopPropagation()
        action(event)
    }
}